import { render, staticRenderFns } from "./404.vue?vue&type=template&id=a12afef2&"
import script from "./404.vue?vue&type=script&lang=js&"
export * from "./404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp7.4.1\\htdocs\\e2e-invoicing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a12afef2')) {
      api.createRecord('a12afef2', component.options)
    } else {
      api.reload('a12afef2', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=a12afef2&", function () {
      api.rerender('a12afef2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/errors/404.vue"
export default component.exports